// Angular dependencies
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageCreepRouterModule } from './page-creep.router';
import { CoreModule } from '../core.module';

// Page main component
import { PageCreepComponent } from './page-creep.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    // Page route
    PageCreepRouterModule
  ],
  declarations: [
    PageCreepComponent
  ]
})
export class PageCreepModule { }



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep.module/page-creep.module.ts